import React, { FC, memo, MutableRefObject, ReactElement, useRef, useState } from 'react'
import { PopperPlacementType } from '@material-ui/core'
import { AssetEntryMap, HelpEntry } from '../../API/Contentful/Types'
import { ReactState } from '../../Types/Types'
import Icon, { IconName } from '../Icon'
import PopperBubble from '../PopperBubble'
import { WYSIWYGDisplay } from '../WYSIWYGDisplay/WYSIWYGDisplay'
import { IconSize } from '../../../../NonReact/constants/React/Icon/Constants'
import { IsVarEmpty } from '../../../../NonReact/utils/GlobalFunctions'

type Props = {
    className?: string
    helpEntry: Definable<HelpEntry>
    assets: Definable<AssetEntryMap>
    position?: PopperPlacementType
    iconSize?: IconSize
}

/**
 * Display a help entry in a tooltip with data from the Contentful API.
 *
 * @param className - The class name to apply to the component.
 * @param helpEntry - The help entry to display.
 * @param assets - The assets to display from contentful in the contentful AssetEntryMap format.
 * @param position - The position of the tooltip.
 */
export const HelpEntryTooltip: FC<Props> = memo(
    ({ className, helpEntry, assets, position, iconSize }: Props): ReactElement => {
        const [isOpen, setIsOpen]: ReactState<boolean> = useState<boolean>(false)
        const triggerElement: MutableRefObject<null> = useRef<null>(null)

        return helpEntry ? (
            <span className={`help-entry-tooltip ${className ?? ''}`}>
                <span
                    className='het-trigger'
                    ref={triggerElement}
                    onMouseOver={(): void => setIsOpen(true)}
                    onMouseOut={(): void => setIsOpen(false)}
                >
                    <Icon
                        iconSize={IsVarEmpty(iconSize) ? IconSize.MEDIUM : iconSize}
                        iconName={IconName.QUESTION_MARK}
                    />
                </span>
                <PopperBubble
                    className='help-popover-content'
                    anchorEl={triggerElement.current}
                    open={isOpen}
                    content={<WYSIWYGDisplay content={helpEntry.content} assets={assets} />}
                    placement={`${position || 'top'}`}
                    infoMode
                    onMouseOver={(): void => setIsOpen(true)}
                    onMouseOut={(): void => setIsOpen(false)}
                />
            </span>
        ) : (
            <></>
        )
    }
)
